import { createContext, Dispatch, SetStateAction, useContext } from 'react';
import { PrepRequestType } from 'models/prep-request.model';

export type PrepTramRequestContextType = {
  setItemRequestToEdit: Dispatch<SetStateAction<PrepRequestType>>;
  itemRequestToEdit: PrepRequestType;
};

export const PrepTeamRequestContext = createContext({} as PrepTramRequestContextType);
const usePrepTeamRequestContext = () => {
  const context = useContext(PrepTeamRequestContext);
  return context;
};

export default usePrepTeamRequestContext;
